import React from 'react';
import { Input, Button, CheckboxTable, Select, PaperClip } from 'components';
import { UserService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, checkPermission } from 'utils';
import { PlanService } from 'services';
import { WhiteImage } from 'assets/img';
import { CheckWhiteIcon } from 'assets/icons';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalUpdate extends React.Component<Props> {

	state = {
		form: {
			name: '',
			year_price: ''
		},
		modules: [],
		image: null,
		plan_modules: {}
	}

	componentDidMount() {
		this.setState({
			form: {
				...this.state.form,
				name: this.props.item?.name || '',
				year_price: this.props.item?.year_price || '',
			}
		});

		this.load();
	}

	load = async () => {
		const res: any = await PlanService.admin.getModules();

		for (let i = 0; i < res.modules.length; i++) {
			const item = this.props.item?.modules?.find((item: any) => item.module_id == res.modules[i].id);

			if (item != null) {
				res.modules[i].active = true;
				res.modules[i].unlimited = item?.unlimited || false;
				res.modules[i].uses = item?.uses || '';
			}
		}

		this.setState({
			modules: res.modules || [],
			plan_modules: res.plan_modules || {}
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	submit = async (e: any) => {
		e.preventDefault();

		const item = this.state.modules.find((i: any) => i.active && !i.uses && !i.unlimited);

		if (item) {
			Globals.showError("Por favor, ingrese los usos de todos los modulos seleccionados");
			return;	
		}

		await PlanService.admin.save({
			plan_id: this.props.item?.id,
			...this.state.form,
			hasFile: true,
			// @ts-ignore,
			image: this.state.image?.value || '',
			modules: JSON.stringify(this.state.modules.filter((i: any) => i.active))
		});
		Globals.showSuccess("Se ha modificado el plan correctamente");
		this.props.onClose();
	}

	render() {
		return (
			<div id="modal-update-plan">
				<div className="container-image">
					<PaperClip
						formats={['png', 'jpg', 'jpeg']}
						value={this.state.image}
						width={1080}
						height={1080}
						onChange={(e: any) => {
							this.setState({
								image: e.target
							})
						}}>
						<div className="image">
							{/*
							// @ts-ignore */}
							<img src={this.state.image?.dataURL || (this.props.item?.image && Constants.BASE_STORAGE + this.props.item?.image) || WhiteImage} />
						</div>
					</PaperClip>
					<p>Subir imagen con una resolución máxima de 1080px*1080px</p>
				</div>
				<Input
					color="white"
					value={ this.state.form.name }
					name="name" 
					className="input-name"
					placeholder="Nombre"
					onChange={ this.change } />
				{
					this.props.item?.id != Constants.PLANS.FREE && (
						<div className="container-input-price">
							<p>$</p>
							<Input
								type="decimal"
								color="white"
								value={ this.state.form.year_price }
								name="year_price" 
								className="input-price"
								label="Costo Anual"
								onChange={ this.change } />
						</div>
					)
				}
				<table className="table">
					<thead>
						<tr>
							<th>Módulos</th>
							<th className="text-right"></th>
						</tr>
					</thead>
					<tbody>
						{
							// @ts-ignore
							this.state.plan_modules[this.props.item?.year_price > 0 ? 'paid' : 'free']?.map((item: any) => {
								return (
									<tr>
										<td>
											<div className="check-container">
												<div className="check">
													<img src={ CheckWhiteIcon } />
												</div>
												<p>{ item?.name }</p>
											</div>
										</td>
										<td className="bold text-right">{ item?.value }</td>
									</tr>
								)
							})
						}
					</tbody>
				</table>
				<div className="text-center">
					<Button className="btn-submit" onClick={ this.submit }>
						Guardar
					</Button>
				</div>
			</div>
		)
	}
}

export default ModalUpdate;